module.exports = __webpack_public_path__ + "img/DJI_0076.a4472707.jpg";